<h1 mat-dialog-title>{{ 'COMMENTS.ADD_NEW' | translate }}</h1>
<div mat-dialog-content>
  <form #commentAssetForm="ngForm">
    <mat-form-field style="display:inline">
      <mat-label>{{ 'COMMENTS.MODAL_COMMENT' | translate }}</mat-label>
      <textarea matInput placeholder="{{ 'COMMENTS.MODAL_COMMENT_CONTENT' | translate }}" #commentAsset="ngModel" name="commentAsset" [(ngModel)]="comment" maxlength="5000" whitespace></textarea>
      @if (commentAsset.invalid && commentAsset.errors?.['whitespace']) {
        <mat-error>{{ 'ERROR.NOT_ONLY_WHITESPACE' | translate }}</mat-error>
      }
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false">{{'MODAL.CANCEL' | translate}}</button>
  <button mat-button (click)="onSubmit(commentAssetForm)" [disabled]="commentAssetForm.invalid">{{ 'MODAL.ACCEPT' | translate }}</button>
</div>
